import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '@/assets/img18.png';
import _imports_1 from '@/assets/img19.png';
import _imports_2 from '@/assets/img20.png';
import _imports_3 from '@/assets/img21.png';
import _imports_4 from '@/assets/img22.png';
import _imports_5 from '@/assets/img23.png';
import _imports_6 from '@/assets/img24.png';
import _imports_7 from '@/assets/icon9.png';
import _imports_8 from '@/assets/img28.png';
import _imports_9 from '@/assets/img29.png';
import _imports_10 from '@/assets/img30.png';
import _imports_11 from '@/assets/img31.png';
import _imports_12 from '@/assets/img32.png';
import _imports_13 from '@/assets/img33.png';
import _imports_14 from '@/assets/img34.png';
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "common"
};
const _hoisted_3 = {
  class: "flex align-center",
  style: {
    "margin-bottom": "149px"
  }
};
const _hoisted_4 = {
  class: "right-box"
};
const _hoisted_5 = {
  class: "box-bottom flex justify-between align-center"
};
const _hoisted_6 = {
  class: "box-left"
};
const _hoisted_7 = {
  class: "box-left-item-text"
};
const _hoisted_8 = {
  class: "box-left"
};
const _hoisted_9 = {
  class: "box-left-item-text"
};
const _hoisted_10 = {
  class: "zj-container"
};
const _hoisted_11 = {
  class: "common"
};
const _hoisted_12 = {
  class: "zi-list flex justify-between align-center"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "zi-item-title"
};
import { ref } from 'vue';
export default {
  __name: 'index',
  setup(__props) {
    const zjList = ref([{
      icon: require('@/assets/icon10.png'),
      img: require('@/assets/img25.png'),
      title: "与各省市国资公司成立混改公司，由各省市国资公司控股51%"
    }, {
      icon: require('@/assets/icon11.png'),
      img: require('@/assets/img26.png'),
      title: "完全按国资的资金的事权OA审批流程开展。"
    }, {
      icon: require('@/assets/icon12.png'),
      img: require('@/assets/img27.png'),
      title: "所有消费券发放资金进入国资公司在银行开设的政府封闭监管账户。"
    }]);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_cache[9] || (_cache[9] = _createStaticVNode("<div class=\"banner\" data-v-61cb958a></div><div class=\"container\" data-v-61cb958a><div class=\"common\" data-v-61cb958a><div class=\"us-title\" data-v-61cb958a>JING XI HUA FA QUAN</div><h3 class=\"title\" data-v-61cb958a>精细化发券</h3><div class=\"jx-title\" data-v-61cb958a> 根据各省市及下属的各市、县、区、各部门不同的业务需求，个性化开发了各种发券功能与核销逻辑，做到了各市、县、区、各部门发券灵活发 </div><img src=\"" + _imports_0 + "\" width=\"100%\" height=\"auto\" style=\"margin:57px 0 89px 0;\" alt=\"\" data-v-61cb958a></div></div><div class=\"gl-container\" data-v-61cb958a><div class=\"common\" data-v-61cb958a><div class=\"us-title\" data-v-61cb958a>GONG LUE HUA CU XIAO</div><h3 class=\"title\" data-v-61cb958a>攻略化促销</h3><div class=\"jx-title\" data-v-61cb958a> 整合不同部门、不同规则的政企合力券种，开展促消费长链攻略推介：矩阵式引导用户的吃、娱、住、行一体多维消费。 </div><div class=\"img-item flex justify-between align-center\" data-v-61cb958a><img src=\"" + _imports_1 + "\" width=\"145px\" height=\"auto\" alt=\"\" data-v-61cb958a><img src=\"" + _imports_2 + "\" width=\"145px\" height=\"auto\" alt=\"\" data-v-61cb958a><img src=\"" + _imports_3 + "\" width=\"145px\" height=\"auto\" alt=\"\" data-v-61cb958a><img src=\"" + _imports_4 + "\" width=\"145px\" height=\"auto\" alt=\"\" data-v-61cb958a><img src=\"" + _imports_5 + "\" width=\"145px\" height=\"auto\" alt=\"\" data-v-61cb958a></div></div></div>", 3)), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "us-title"
      }, "LI TI HUA FENG KONG", -1)), _cache[6] || (_cache[6] = _createElementVNode("h3", {
        class: "title"
      }, "立体化风控", -1)), _createElementVNode("div", _hoisted_3, [_cache[4] || (_cache[4] = _createElementVNode("img", {
        src: _imports_6,
        width: "608",
        height: "343",
        style: {
          "z-index": "10"
        },
        alt: ""
      }, null, -1)), _createElementVNode("div", _hoisted_4, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "right-title"
      }, " 多维度开启订单实时侦测和拦截功能，针对商家、用户的异常情况进行立体监控，实时分秒级，多维度刷单、套现预警： ", -1)), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(['诚信经营承诺信义分', '用户黑名单', ' 秒级订单量波动；', ' 同行均价对比振幅；', ' 支付行为异常监测；'], (item, index) => {
        return _createElementVNode("div", {
          class: "box-left-item flex",
          key: index
        }, [_cache[0] || (_cache[0] = _createElementVNode("img", {
          src: _imports_7,
          style: {
            "width": "10px",
            "height": "13px",
            "margin-right": "10px"
          },
          alt: ""
        }, null, -1)), _createElementVNode("div", _hoisted_7, _toDisplayString(item), 1)]);
      }), 64))]), _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "line"
      }, null, -1)), _createElementVNode("div", _hoisted_8, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(['纵向交易波动异常；', '定位区域校验；', '单价支付类同率；', '举报投诉分析；', '.......'], (item, index) => {
        return _createElementVNode("div", {
          class: "box-left-item flex",
          key: index
        }, [_cache[1] || (_cache[1] = _createElementVNode("img", {
          src: _imports_7,
          style: {
            "width": "10px",
            "height": "13px",
            "margin-right": "10px"
          },
          alt: ""
        }, null, -1)), _createElementVNode("div", _hoisted_9, _toDisplayString(item), 1)]);
      }), 64))])])])])])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_cache[7] || (_cache[7] = _createElementVNode("div", {
        class: "us-title"
      }, "ZI JIN AN QUAN BAO ZHANG", -1)), _cache[8] || (_cache[8] = _createElementVNode("h3", {
        class: "title"
      }, "资金安全保障", -1)), _createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(zjList.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "zi-item",
          key: index
        }, [_createElementVNode("img", {
          src: item.img,
          style: {
            "width": "377px",
            "height": "265px"
          },
          alt: ""
        }, null, 8, _hoisted_13), _createElementVNode("img", {
          src: item.icon,
          style: {
            "width": "40px",
            "height": "40px"
          },
          class: "zi-list-icon",
          alt: ""
        }, null, 8, _hoisted_14), _createElementVNode("div", _hoisted_15, _toDisplayString(item.title), 1)]);
      }), 128))])])]), _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"container\" data-v-61cb958a><div class=\"common\" data-v-61cb958a><div class=\"us-title\" style=\"margin-top:100px;\" data-v-61cb958a> SHU JU AN QUAN BAO ZHANG</div><h3 class=\"title\" data-v-61cb958a>数据安全保障</h3><img src=\"" + _imports_8 + "\" width=\"100%\" height=\"auto\" style=\"margin:27px 0 89px 0;\" alt=\"\" data-v-61cb958a></div></div><div class=\"yj-container\" data-v-61cb958a><div class=\"common\" data-v-61cb958a><div class=\"us-title\" data-v-61cb958a>YING JI YU AN BAO ZHANG</div><h3 class=\"title\" data-v-61cb958a>应急预案保障</h3><div class=\"yj-list\" data-v-61cb958a><div class=\"yj-item\" data-v-61cb958a><img src=\"" + _imports_9 + "\" alt=\"\" data-v-61cb958a><div class=\"yj-item-text\" data-v-61cb958a> 企业级数据库服务器，满足高量级访问时的数据安全保障。 </div></div><div class=\"yj-item\" data-v-61cb958a><div class=\"yj-item-text\" data-v-61cb958a> 百台服务器负载均衡，应对异常突发的访问数据并发过载，做到流量自动微秒级切换。 </div><img src=\"" + _imports_10 + "\" alt=\"\" data-v-61cb958a></div><div class=\"yj-item\" data-v-61cb958a><img src=\"" + _imports_11 + "\" alt=\"\" data-v-61cb958a><div class=\"yj-item-text\" data-v-61cb958a> 专业运维团队，24小时应急备战，杜绝系统出错。 </div></div><div class=\"yj-item\" data-v-61cb958a><div class=\"yj-item-text\" data-v-61cb958a> 高等级的安全插件，防范各类型黑客攻击。 </div><img src=\"" + _imports_12 + "\" alt=\"\" data-v-61cb958a></div></div></div></div><div class=\"container\" data-v-61cb958a><div class=\"common\" data-v-61cb958a><div class=\"us-title\" data-v-61cb958a> HE ZHANG JING ZHUN BAO ZHANG </div><h3 class=\"title\" data-v-61cb958a>核账精准保障</h3><div class=\"jx-title\" style=\"margin-bottom:43px;\" data-v-61cb958a> 三端一舱一脑实时数据分析，各维度数据一一对应，多端相佐证对账，按审计要求实时对账，做到审计数据无差错。 </div><img src=\"" + _imports_13 + "\" width=\"100%\" height=\"auto\" style=\"margin:27px 0 89px 0;\" alt=\"\" data-v-61cb958a></div></div><div class=\"container\" data-v-61cb958a><div class=\"common\" data-v-61cb958a><div class=\"us-title\" data-v-61cb958a> SHU JU FNE XI BAO ZHANG </div><h3 class=\"title\" data-v-61cb958a>数据分析保障</h3><div class=\"sj-content flex align-center justify-between\" data-v-61cb958a><div class=\"sj-text\" data-v-61cb958a> 先进的大数据分析技术，对各市、县、区的促消费数据进行实时全面分析，并专人汇报，为制定促消政策、及时调整促消费措施，提供辅助材料; </div><img src=\"" + _imports_14 + "\" style=\"width:586px;height:373px;\" alt=\"\" data-v-61cb958a></div></div></div>", 4))], 64);
    };
  }
};